export const USER_STATUS: { [key: string]: string } = {
  0: 'Inactive',
  1: 'Active',
  2: 'Invited',
  3: 'Resend',
}